import * as React from 'react';

export interface PriceMessagesProps {
  priceMessages: string[];
}

export const PriceMessages: React.FunctionComponent<PriceMessagesProps> = ({ priceMessages }) => (
  <div className="all-t-padding-one" data-stid="price-messages">
    {priceMessages.map(message => (
      <div className="pwa-theme--grey-700 uitk-type-100 uitk-type-regular" key={message}>
        {message}
      </div>
    ))}
  </div>
);
PriceMessages['displayName'] = 'PriceMessages';

export interface NumberOfNightsAndRoomsProps {
  numberOfNightsAndRooms?: string;
}

export const NumberOfNightsAndRooms: React.FunctionComponent<NumberOfNightsAndRoomsProps> = ({ numberOfNightsAndRooms }) =>
  numberOfNightsAndRooms ? (
    <div className="numberOfNightsAndRooms pwa-theme--grey-700 uitk-type-100 uitk-type-regular">{numberOfNightsAndRooms}</div>
  ) : null;
NumberOfNightsAndRooms['displayName'] = 'NumberOfNightsAndRooms';

export interface PriceMessagesContainerProps {
  priceMessages?: string[];
  numberOfNightsAndRooms?: string;
}

export const PriceMessagesContainer: React.FunctionComponent<PriceMessagesContainerProps> = props => {
  const { priceMessages, numberOfNightsAndRooms } = props;

  return priceMessages ? <PriceMessages {...{ priceMessages }} /> : <NumberOfNightsAndRooms {...{ numberOfNightsAndRooms }} />;
};
PriceMessagesContainer['displayName'] = 'PriceMessagesContainer';
